module.exports = __webpack_public_path__ + "img/20220420145141.b0005280.png";